import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface Notification {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  id: number;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationsSubject = new BehaviorSubject<Notification[]>([]);
  notifications$ = this.notificationsSubject.asObservable();

  private idCounter = 0;

  constructor() {}

  show(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') {
    const newNotification: Notification = {
      message,
      type,
      id: this.idCounter++,
    };

    this.notificationsSubject.next([...this.notificationsSubject.value, newNotification]);

    // Auto-hide after 3 seconds
    setTimeout(() => this.hide(newNotification.id), 3000);
  }

  hide(notificationId: number) {
    this.notificationsSubject.next(
      this.notificationsSubject.value.filter((n) => n.id !== notificationId)
    );
  }
}
